export const DEFAULT_SCREEN_ID = "ribbon-of-worth";

export const WORDPRESS_HOME = "http://dev.mediajackagency.com/clients/dawna/row/wordpress/"

export const URL = {
    screenUrl: "http://dev.mediajackagency.com/clients/dawna/row/wordpress/wp-json/wp/v2/",
    slugUrl: "http://dev.mediajackagency.com/clients/dawna/row/wordpress/wp-json/row/v1/all-slugs?order=asc",
    newsUrl: "http://dev.mediajackagency.com/clients/dawna/row/wordpress/news/",
    aboutUrl: "http://dev.mediajackagency.com/clients/dawna/row/wordpress/about/"
}

let _basename = "/clients/dawna/row/build/";
if (window.cordova) _basename = "/";
export const BASENAME_URL = _basename;

export default {
    URL,
    DEFAULT_SCREEN_ID,
    WORDPRESS_HOME,
    BASENAME_URL
}